module.exports = __webpack_public_path__ + "img/twoInterger.30d477f5.png";